import LoadingComponent from "components/generalComponents/loadingComponent/LoadingComponent";
import StatCard from "components/generalComponents/statCard/StatCard";
import { PureComponent, ReactNode } from "react";
import { strings } from "utils/localizedStrings";
import RevCurMonthIcon from "../../icons/rev_cur_month.png";
import RevPrevMonthIcon from "../../icons/rev_prev_month.png";
import RevTodayIcon from "../../icons/rev_today.png";
import SaleCurMonthIcon from "../../icons/sale_cur_month.png";
import SalePrevMonthIcon from "../../icons/sale_prev_month.png";
import SaleTodayIcon from "../../icons/sale_today.png";
import {
  GeneralStatCard,
  IGeneralStatCardsProps,
} from "../../interfaces/IGenerals";

interface GeneralStatCardConfig {
  key: string;
  icon: string;
  iconAlt: string;
  iconContainerClassName: string;
  iconColorClassName: string;
  label: string;
  stat: GeneralStatCard;
}

export default class GeneralStatCardsComponent extends PureComponent<IGeneralStatCardsProps> {
  private renderCard = ({
    key,
    icon,
    iconAlt,
    iconContainerClassName,
    iconColorClassName,
    label,
    stat,
  }: GeneralStatCardConfig): ReactNode => {
    const { loading } = this.props;

    return (
      <StatCard
        key={key}
        title={`${label} ${stat.currentTime}`}
        value={loading ? <LoadingComponent color="black" /> : stat.value}
        trend={
          stat.change && !loading
            ? {
                direction: stat.trend,
                text: `${stat.change} ${strings.General.Revenue.CompareWith} ${stat.previousTime}`,
              }
            : undefined
        }
        icon={<img src={icon} alt={iconAlt} className="w-5 h-5" />}
        iconContainerClassName={iconContainerClassName}
        iconColorClassName={iconColorClassName}
      />
    );
  };

  render(): ReactNode {
    const { statCards } = this.props;
    const cards: GeneralStatCardConfig[] = [
      {
        key: "todayRevenue",
        label: strings.General.Revenue.Label,
        stat: statCards.todayRevenue,
        icon: RevTodayIcon,
        iconAlt: "Revenue Today",
        iconContainerClassName: "bg-green-50",
        iconColorClassName: "text-green-600",
      },
      {
        key: "monthRevenue",
        label: strings.General.Revenue.Label,
        stat: statCards.monthRevenue,
        icon: RevCurMonthIcon,
        iconAlt: "Revenue Current Month",
        iconContainerClassName: "bg-blue-50",
        iconColorClassName: "text-blue-600",
      },
      {
        key: "previousMonthRevenue",
        label: strings.General.Revenue.Label,
        stat: statCards.previousMonthRevenue,
        icon: RevPrevMonthIcon,
        iconAlt: "Revenue Previous Month",
        iconContainerClassName: "bg-[#E2702A]/15",
        iconColorClassName: "text-[#E2702A]",
      },
      {
        key: "todayTransactions",
        label: strings.General.Revenue.Transaction,
        stat: statCards.todayTransactions,
        icon: SaleTodayIcon,
        iconAlt: "Transactions Today",
        iconContainerClassName: "bg-purple-50",
        iconColorClassName: "text-purple-600",
      },
      {
        key: "monthTransactions",
        label: strings.General.Revenue.Transaction,
        stat: statCards.monthTransactions,
        icon: SaleCurMonthIcon,
        iconAlt: "Transactions Current Month",
        iconContainerClassName: "bg-rose-50",
        iconColorClassName: "text-rose-600",
      },
      {
        key: "previousMonthTransactions",
        label: strings.General.Revenue.Transaction,
        stat: statCards.previousMonthTransactions,
        icon: SalePrevMonthIcon,
        iconAlt: "Transactions Previous Month",
        iconContainerClassName: "bg-[#10DDDD]/15",
        iconColorClassName: "text-[#10DDDD]",
      },
    ];

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {cards.map(this.renderCard)}
      </div>
    );
  }
}
